import Vue from 'vue'
import Router from 'vue-router'
import Login from './components/Login.vue'
import Home from './components/home/Home.vue'
import Welcome from './components/home/test.vue'
import shenqingshu from './components/std_module/shenqingshu.vue'
import Activity_wxd from './components/std_module/activity_wxd.vue'
import Activity_wcz from './components/std_module/activity_wcz.vue'
import Activity_wxf from './components/std_module/activity_wxf.vue'
import RoleList from './components/admin_module/role_list.vue'
import UserList from './components/admin_module/user_list.vue'
import UserScore from './components/admin_module/user_score.vue'
import activityAdmin from './components/admin_module/activity_admin.vue'
import zzwyXslist from './components/zzwy_module/zzwy_xslist.vue'
import zzwyActivity from './components/zzwy_module/zzwy_activity.vue'
import Wjf from './components/std_module/wjf.vue'
import Activity_wfw from './components/std_module/activity_wfw'
import xsList from './components/teacher_module/xs_list.vue'
import xsActivity from './components/teacher_module/xs_activity.vue'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/login'

    },
    {
      path: '/login',
      component: Login,
      meta: {
        title: "智慧党建平台"
      }
    },
    
    {
      path: '/home',
      component: Home,
     
      children: [
        {
          path: '/welcome',
          component: Welcome,
          meta: {
            title: "用户信息管理"
          }
        },
      //管理员模块
      {
        path: '/userlist',
        component: UserList,
        meta: {
          title: "用户信息管理"
        }
      },{
        path: '/rolelist',
        component: RoleList,
        meta: {
          title: "角色管理"
        }
      }, {
        path: '/userscore',
        component: UserScore,
        meta: {
          title: "活动考核分数"
        }
      }, {
        path: '/adminActivity',
        component: activityAdmin,
        meta: {
          title: "管理员活动管理"
        }
      },


     //党员老师模块
     {
      path: '/xslist',
      component: xsList,
    
    },
    {
      path: '/xsactivity',
      component: xsActivity,
    
    },
   //组织委员模块
   {
    path: '/zzwyList',
    component: zzwyXslist,
  
  },
  {
    path: '/zzwyActivity',
    component: zzwyActivity,
  
  },
  


    //发展对象模块
        {
          path: '/wxy',
          component: shenqingshu,
        
        },
        {
          path: '/wxd',
          component: Activity_wxd,
          meta: {
            title: "微行动管理"
          }
        }, {
          path: '/wcz',
          component: Activity_wcz,
          meta: {
            title: "微成长管理"
          }
        },{
          path: '/wxf',
          component: Activity_wxf,
          meta: {
            title: "微学分管理"
          }
        },  {
          path: '/wfw',
          component: Activity_wfw,
          meta: {
            title: "微服务管理"
          }
        }, 
       {
          path: '/base',
          component: Wjf,
          meta: {
            title: "基础信息"
          }
        }
        // {
        //   path: '/accountSerring',
        //   component:accountSetting 
        // },
      ]
    },
    
  ]
})
